<template>
  <div class="container">
    <div class="s_">
      <van-nav-bar
        title="选择科目"
        class="fixedtop"
        left-arrow
        @click-left="goBackFn"
      />
      <div class="home_">
        <div class="top__nav">
          <div class="nav_items">
            <div
              class="top_nas"
              :class="item.is_weigh == true ? 'is__weight' : ''"
              v-for="(item, index) in cateList"
              :key="index"
              @click.stop="changedCate(index)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
        <!-- 列表 -->
        <div class="top_four" v-if="homeList.length != 0">
          <div
            class="lit_kecheng"
            v-for="(item, index) in homeList"
            :key="index"
            @click="goDetailsList(item.id)"
          >
            <div class="kemu__list">
              <div class="left_imgs">
                <img :src="item.video_image" class="bigleft__img" alt="" />
                <div class="left__position">
                  <div class="ke_cate_name">
                    {{ item.is_major == 1 ? "必修" : "选修" }}
                  </div>
                  <img
                    src="../../assets/image/jin_07.png"
                    class="cate__bg"
                    alt=""
                  />
                </div>
                <div class="right_box">
                  <div class="names__ke two_text">{{ item.tag }}</div>
                </div>
              </div>
              <div class="right__kecheng">
                <div class="ke_bigtitle t_text">
                  {{ item.name }}
                </div>
                <div class="shi_chang two_text">
                  时长：{{ item.class_hour }}课时
                </div>
                <div class="jiang_shi two_text">讲师：{{ item.teacher }}</div>
              </div>
            </div>
          </div>
          <div v-if="nomore == true" class="no_more">没有更多了</div>
        </div>
        <div class="elseimg" v-else>
          <img
            src="../../assets/image/jin_09.png"
            alt
            v-if="it_cloose == true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      homeList: [],  //列表
      cateList: [
        {
          type: 1,
          title: '全部',
          is_weigh: true,
        },
        {
          type: 2,
          title: '必修',
          is_weigh: false,
        },
        {
          type: 3,
          title: '选修',
          is_weigh: false,
        }
      ],
      it_cloose: false,
      nomore: false,
      total: 0,
      reqParams: {
        id: '',
        type: 0,  //类型1或者空是全部2必修3选修
        page: 0,
        pageNum: 10
      }

    };
  },
  created() {
    let that = this;
    const routeParams = this.$route.query;
    that.reqParams.id = routeParams.id
    this.getHomeList()
    window.onscroll = function () {
      // scrollTop 滚动条滚动时，距离顶部的距离
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // windowHeight 可视区的高度
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      // scrollHeight 滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      // 滚动条到底部的条件
      // alert(windowHeight + scrollTop)
      // alert(scrollHeight)
      // 滚动条的总高度-1，适配手机分页
      if (scrollTop + windowHeight >= scrollHeight-1) {
        // 加载数据
        if (that.total != that.homeList.length) {
          that.getHomeList();
        } else {
          that.nomore = true
        }
      }
    }
  },
  methods: {
    goBackFn() {      // 回到上一步
      this.$router.go(-1);
    },
    changedCate(index) {
      let that = this, send = index, list = that.cateList, type = that.reqParams.type;
      that.it_cloose = false
      list.forEach((item, index) => {
        item.is_weigh = false
        if (send == index) {
          item.is_weigh = true
          type = item.type
        }
      })
      that.cateList = list
      that.reqParams.type = type
      that.homeList = []
      that.reqParams.page = 0
      that.getHomeList()
    },
    async getHomeList() {  // 首页列表 
      let that = this
      try {
        this.reqParams.page++;
        // console.log(this.reqParams.page);
        const { data: { data } } = await this.postRequest('api/user/video_list', this.reqParams)
        // console.log(data);

        this.total = data.total_num
        this.homeList = this.homeList.concat(data.info);
        if (that.homeList.length == 0) {
          this.it_cloose = true
        }
      } catch (err) {
        // console.log(err);
      }
    },
    goDetailsList(item) {
      this.$router.push({ path: "/detailsList", query: { id: item } })
    },
  }
};
</script>

<style scoped lang='less'>
.container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .s_ {
    .fixedtop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background-color: #fff;
      z-index: 10;

      .logo {
        width: 100%;
        height: 64px;
        display: flex;
        align-items: center;
        padding: 12px 16px;
        box-sizing: border-box;
        img {
          max-width: 100%;
          max-height: 100%;
        }
        .ck {
          width: 100%;
          margin-left: 20px;
          input {
            width: 100%;
            height: 64px;
          }
        }
      }
    }

    .home_ {
      //   轮播图
      width: 100%;
      padding: 60px 0 80px;
      box-sizing: border-box;

      .top__nav {
        width: 100%;
        padding: 0 16px;
        box-sizing: border-box;
        height: 44px;
        border-bottom: 1px solid #e3e3e3;
        background-color: #fff;

        .nav_items {
          width: 100%;
          display: flex;
          align-items: center;
          height: 44px;

          .top_nas {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-family: PingFangSC-Regular;
            color: #232323;
          }

          .is__weight {
            position: relative;
            color: #3e8bff;
            height: 44px;

            &::after {
              content: "";
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
              z-index: 2;
              width: 40px;
              height: 2px;
              opacity: 1;
              background: #3e8bff;
            }
          }
        }
      }
      .top_four {
        background-color: #fff;
        width: 100%;
        padding: 0 16px;
        box-sizing: border-box;
        .lit_kecheng {
          width: 100%;
          padding: 16px 0;
          box-sizing: border-box;
          border-bottom: 1px solid #eeeeee;

          .kemu__list {
            width: 100%;
            display: flex;
            align-items: center;

            .left_imgs {
              width: 173px;
              height: 98px;
              border-radius: 4px;
              flex-shrink: 0;
              position: relative;

              .bigleft__img {
                width: 173px;
                height: 98px;
                border-radius: 4px;
              }

              .left__position {
                position: absolute;
                top: 6px;
                left: 0;
                width: 46px;
                height: 20px;

                .cate__bg {
                  width: 46px;
                  height: 20px;
                }

                .ke_cate_name {
                  width: 46px;
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  z-index: 5;
                  transform: translate(-50%, -50%);
                  text-align: center;
                  line-height: 20px;
                  color: #fff;
                }
              }

              .right_box {
                width: 100px;
                height: 26px;
                opacity: 0.6;
                background: #06121e;
                border-radius: 0px;
                position: absolute;
                right: 0;
                top: 0;
                z-index: 3;
                padding: 0 8px;
                box-sizing: border-box;

                .names__ke {
                  width: 100%;
                  height: 26px;
                  opacity: 1;
                  font-size: 12px;
                  font-family: PingFang SC, PingFang SC-Bold;
                  font-weight: 700;
                  text-align: center;
                  color: #ffffff;
                  line-height: 26px;
                }
              }
            }

            .right__kecheng {
              flex: 1;
              height: 98px;
              padding-left: 16px;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              justify-content: space-around;

              .ke_bigtitle {
                width: 100%;
                font-size: 14px;
                font-family: PingFangSC-Medium;
                text-align: left;
                color: #3d444c;
              }

              .shi_chang,
              .jiang_shi {
                font-size: 12px;
                font-family: PingFangSC-Regular;
                text-align: left;
                color: #8c9198;
                letter-spacing: 0px;
              }

              .jiang_shi {
              }
            }
          }

          &:last-child {
            border-bottom: 0 none;
          }
        }
      }
      .no_more {
        width: 100%;
        padding: 20px 0;
        box-sizing: border-box;
        text-align: center;
        font-size: 14px;
        color: #5d5d5d;
      }
      .elseimg {
        width: 100%;
        padding: 16px 16px 0;
        box-sizing: border-box;
        img {
          width: 100%;
        }
      }
      .currentpae {
        padding: 0 16px;
        box-sizing: border-box;
        background-color: #f9f9f9;
      }
      .top_five {
        background-color: #f9f9f9;
        padding: 10px 16px 80px;
        box-sizing: border-box;
        .photos {
          .small_box {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            .foot {
              width: 100px;
              height: 40px;
              margin: 5px;
              background-color: #fff;
              border: 1px #ccc solid;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 24px;
                height: 24px;
              }
              span {
                padding-left: 5px;
                box-sizing: border-box;
                color: black;
                font-size: 12px;
              }
            }
          }
        }
        .record {
          margin-top: 16px;
          p {
            color: #5d5d5d;
            text-align: center;
          }
          p:nth-child(1) {
            line-height: 30px;
          }
          p:nth-child(2) {
            line-height: 30px;
            // margin: 10px 0;
          }
          p:nth-child(3) {
            line-height: 30px;
          }
        }
      }
      .top_six {
        position: fixed;
        right: 5px;
        bottom: 80px;
        .ash {
          margin-top: 15px;
          .ash_ash {
            width: 48px;
            height: 48px;
            img {
              width: 48px;
              height: 48px;
            }
          }
        }
      }
      .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        z-index: 5;

        .block {
          width: 343px;
          height: 215px;
          position: relative;
          img:nth-child(1) {
            width: 100%;
          }
          img:nth-child(2) {
            width: 45px;
            height: 45px;
            position: absolute;
            top: 112px;
            left: 148px;
          }
          img:nth-child(3) {
            width: 21px;
            height: 21px;
            position: absolute;
            top: 10px;
            right: 10px;
          }
        }
      }
    }

    .wrapperwecode {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;

      .block {
        width: 240px;
        height: 240px;
        background-color: #fff;
        img {
          width: 100%;
        }
      }
    }
  }
  .loading {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 500px;
  }
}
</style>